module.exports = __WEBPACK_EXTERNAL_MODULE_37__;


//////////////////
// WEBPACK FOOTER
// external "ecCom"
// module id = 37
// module chunks = 0